'use strict';

/** @typedef {import('../pipelineStatusTypes').PipelineStatusStage} PipelineStatusStage */

import React from 'react';
import {
	Box,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/** @param {unknown} v */
function displayOrDash(v) {
	if (v == null) return '—';
	const s = String(v).trim();
	return s === '' ? '—' : s;
}

/**
 * @param {{
 *   stage: PipelineStatusStage | null;
 *   open: boolean;
 *   onClose: () => void;
 * }} props
 */
export function PipelineStatusDrawer({ stage, open, onClose }) {
	const title = stage?.description?.trim() ? stage.description.trim() : 'Stage';

	return (
		<Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 400 }, maxWidth: '100%' } }}>
			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
				<Typography variant="h6" component="div" sx={{ fontSize: '1rem', fontWeight: 600, pr: 1 }}>
					{title}
				</Typography>
				<IconButton aria-label="Close drawer" onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</Box>
			<Divider />
			{stage ? (
				<Box sx={{ px: 2, py: 2 }}>
					<List dense disablePadding>
						<ListItem disableGutters>
							<ListItemText primary="Status" secondary={displayOrDash(stage.status)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Started at" secondary={displayOrDash(stage.startedAt)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Completed at" secondary={displayOrDash(stage.completedAt)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Occurred at" secondary={displayOrDash(stage.occurredAt)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Correlation ID" secondary={displayOrDash(stage.correlationId)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Scope" secondary={displayOrDash(stage.scope)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Workflow" secondary={displayOrDash(stage.workflow)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Subject id" secondary={displayOrDash(stage.subjectId)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Service" secondary={displayOrDash(stage.service)} />
						</ListItem>
						<ListItem disableGutters>
							<ListItemText primary="Service version" secondary={displayOrDash(stage.serviceVersion)} />
						</ListItem>
					</List>
				</Box>
			) : null}
		</Drawer>
	);
}
